import * as React from "react";
import { Form, Text, Radio, TextArea, Checkbox } from 'react-form';
import { api, dataList } from "src/services/api";
import { bindToAPI } from "src/services/form";
import { asset } from "src/services/theme";
import { Formatters, Tabs } from "src/components/ui";
import IndirizziFatturazione from "./IndirizziFatturazione";

interface Props {
  items: {
    nome: string,
    descrizione?: string,
    prezzo: number
  }[];
  onSubmit?: Function;
  onBack?: Function;
}

interface State {
  phase: string;
  subPhase?: string;
  indirizzo?: any;
  codice?: string;
  sconto?: number | null;
  payment: "CARD" | "PAYPAL"
}

export default class OrdineCheckout extends React.Component<Props, State> {
  state = {
    phase: "INDIRIZZI",
    codice: "",
    payment: "CARD"
  } as any;
  
  onChangeInput(field, event) {
    this.setState({
      [field]: event.target.value
    } as any);
  }
  
  getTotale() {
    const { items } = this.props;
    return items.reduce( (acc, item) => {
      return acc + (item.prezzo);
    }, 0)
  }
  
  getSconto() {
    const { sconto = 0 } = this.state;
    return this.getTotale() * sconto / 100;
  }
  
  changeIndirizzo(indirizzo) {
    this.setState({
      indirizzo
    });
  }
  
  editingIndirizzo(indirizzo) {
    this.setState({
      subPhase: indirizzo ? "EDITING_ADDR" : null
    } as any);
  }
  
  async checkCodiceSconto( ) {
    const { codice } = this.state;
    // verify codice
    try {
      const data = await api({
        method: "POST",
        url: "ecommerce/checkCodiceSconto",
        data: {
          codice
        },
        loading: this,
        appActions: true
      });
      this.setState({
        sconto: data.sconto
      });
    } catch(errors) {
    }
  }
  
  back() {
    const { onBack } = this.props;
    if (onBack) {
      onBack();
    }
  }
  
  submit() {
    const { onSubmit } = this.props;
    const { indirizzo, codice } = this.state;
    if (onSubmit) {
      onSubmit( {
          indirizzo,
          codice
      } );
    }
  }
  
  render() {
    const { items } = this.props;
    const { current, phase, subPhase, item, indirizzi = [], indirizzo, payment, codice, sconto } = this.state;
    
    return (
      <div className="ecommerce_OrdineCheckout">
        <section>
          <div className="order">
            <Tabs activeKey={phase} onChange={(phase) => this.setState({ phase })}>
              <span key="INDIRIZZI">01 Dati fatturazione</span>
              <span key="PAGAMENTO">02 Pagamento</span>
            </Tabs>
            {phase === "INDIRIZZI" &&
            <section>
              <IndirizziFatturazione
                onChange={(indirizzo) => this.changeIndirizzo(indirizzo)}
                onEdit={(indirizzo) => this.editingIndirizzo(indirizzo)}
              />
            </section>
            }
            {phase === "PAGAMENTO" &&
            <section className="payment">
              <header>
                <h3>Seleziona metodo di pagamento</h3>
              </header>
              <article className={payment === "CARD" ? "active" : ""} onClick={() => this.setState({payment: "CARD"})}>
                <span className="checker"><span className={payment === "CARD" ? "icon-radio-on" : "icon-radio-off"} /></span>
                <div>
                  <h4>Carta di credito</h4>
                  <p>Trasferimento sicuro con la tua carta di credito. Visa, Maestro, Discover, American Express.</p>
                </div>
                <div>
                  <img src={asset(`pages/ecommerce/creditcards.png`)} />
                </div>
              </article>
              <article className={payment === "PAYPAL" ? "active" : ""} onClick={() => this.setState({payment: "PAYPAL"})}>
                <span className="checker"><span className={payment === "PAYPAL" ? "icon-radio-on" : "icon-radio-off"} /></span>
                <div>
                  <h4>PayPal</h4>
                  <p>Verrai reindirizzato automaticamente al sito PayPal per completare in sicurezza il tuo acquisto</p>
                </div>
                <div>
                  <img src={asset(`pages/ecommerce/paypal.png`)} />
                </div>
              </article>
            </section>
            }
            {subPhase !== "EDITING_ADDR" &&
            <footer className="toolbar">
              {phase === "INDIRIZZI" &&
              <>
              <button type="button" className="wicon pre frameless" onClick={() => this.back()}><span><span className="icon-back" /><em>Indietro</em></span></button>
              {indirizzo &&
              <button type="button" className="md main" onClick={() => this.setState({phase: "PAGAMENTO"})}><span>Prosegui</span></button>
              }
              </>
              }
              {phase === "PAGAMENTO" &&
              <>
              <button type="button" className="wicon pre frameless" onClick={() => this.setState({phase: "INDIRIZZI"})}><span><span className="icon-back" /><em>Indietro</em></span></button>
              <button type="button" className="md main" onClick={() => this.submit()}><span>Completa acquisto</span></button>
              </>
              }
            </footer>
            }
          </div>
          <div className="cart">
            <header>
              <span><span className="icon-shopping_cart" /></span>
              <h3>Il tuo acquisto</h3>
            </header>
            <div className="list">
              {items.map( (item, i) => (
              <article key={i}>
                <span>
                  <strong>{item.nome}</strong>
                  {item.descrizione &&
                  <div dangerouslySetInnerHTML={{__html: item.descrizione}} />
                  }
                </span>
                <span>{Formatters.Price({val: item.prezzo})}</span>
              </article>
              ))}
            </div>
            <div className="discount">
              {!sconto &&
              <>
              <h5>Hai un codice sconto?</h5>
              <div>
                <div>
                  <input type="text" value={this.state.codice} onChange={(e) => this.onChangeInput("codice", e)} className="form-control" />
                </div>
                <div>
                  <button className="cancel" type="button" onClick={() => this.checkCodiceSconto()}><span>Usa</span></button>
                </div>
              </div>
              </>
              }
              {sconto &&
              <>
              <h5>Codice sconto</h5>
              <div>
                <div>
                  {codice}
                </div>
                <div>
                  <strong>{sconto}%</strong>
                </div>
                <div>
                  <button className="frameless onlyicon" onClick={() => this.setState({ codice: "", sconto: null })}><span className="icon-close" /></button>
                </div>
              </div>
              </>
              }
            </div>
            <footer>
              <div>
                <span>Subtotale</span>
                <span>{Formatters.Price({val: this.getTotale()})}</span>
              </div>
              {sconto &&
              <div>
                <span>Sconto</span>
                <span>- {Formatters.Price({val: this.getSconto()})}</span>
              </div>
              }
              <div>
                <strong>Totale</strong>
                <strong>{Formatters.Price({val:this.getTotale() - this.getSconto()})}</strong>
              </div>
            </footer>
          </div>
        </section>
        {phase === "PAGAMENTO" &&
        <footer>
          <img src={asset(`pages/ecommerce/ssl.png`)} />
          <h4>Pagamento sicuro</h4>
          <p>
            Garantiamo la tua sicurezza con una trasmissione dei dati criptata via <strong>Secure Sockets Layer Protocol</strong>.<br />
            Fidati di noi!
          </p>
        </footer>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/OrdineCheckout.tsx